import { useEffect } from "react";
import axios from "axios";
import { baseURL, config, getUser, requestID } from "../../common/utils";
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

const role_id = getUser()?.loginData?.roleID
//console.log("role_id", role_id)
const notificationSound = new Audio("https://192.168.194.100/login/sounds/notification.mp3");

export function showNotification(title: string, body: string) {

  if (Notification.permission === "granted") {
    console.log("Displaying notification:", title, body);
    console.log("Notification.permission:", Notification.permission);


        // Play sound
        notificationSound.play().catch((error) => {
            console.warn("Notification sound failed to play:", error);
          });

          
    toast.info(`${title}: ${body}`, {
        position: "top-right",
        autoClose: 1000,
        theme: "colored",
      });
    new Notification("BeninClub1931 Notification" + title, {
        body: body,
        icon: "/favicon.ico", // Optional icon
        requireInteraction: true,
      });

    //   alert("This is a test notification");
  }
}

export default function NotificationListener({ userId }: { userId: string }) {
  useEffect(() => {

    // Request permission for notifications
    if (Notification.permission !== "granted") {
      Notification.requestPermission().then((permission) => {
        console.log("Notification permission:", permission);
        if (permission !== "granted") {
          alert("Notifications are disabled in your browser.");
        }
      });
    }

    const interval = setInterval(async () => {
      console.log("Polling for notifications...");
      try {
        const formData = new FormData();
        formData.append("requestID", requestID());
        formData.append("roleID", role_id);

       // console.log("formData", role_id);

        const res = await axios.post(
          `${baseURL}orderhistorys/getWaitingOrdersWithItems`,
          formData,
          config
        );
        console.log(res.data)



       res.data.data.map((item: any) => {

        const title = "New Order";
        const message = `New Order: ${item.order_code}  - from ${item.firstName} ${item.middleName} ${item.lastName}`; ;
       
        if (title && message) {
            showNotification(title, message);
          }
       })

      
      
        
      } catch (error) {
        console.error("Failed to fetch notifications:", error);
      }





    }, 600000); // 10 seconds

    return () => clearInterval(interval);
  }, [userId]);

  return null;
}
